type ServiceWorkerContainerLike = {
  register(scriptUrl: string): Promise<unknown>;
};

/**
 * Single source for the registration path: the request spec holds this
 * constant against the Rails route, so a rename on either side fails the
 * suite instead of silently installing a 404 worker (spec 021, R2).
 */
export const SERVICE_WORKER_URL = "/service-worker";

let container: ServiceWorkerContainerLike | null = null;

/**
 * Test seam: injects the browser's `navigator.serviceWorker` container, so
 * tests observe this module instead of stubbing the shared happy-dom
 * navigator (same mechanics as `setGtmEnvironment`).
 */
export function setServiceWorkerContainer(value: ServiceWorkerContainerLike | null): void {
  container = value;
}

export function registerServiceWorker(): void {
  const workerContainer =
    container ??
    (typeof navigator === "undefined"
      ? null
      : ((navigator as Navigator & { serviceWorker?: ServiceWorkerContainerLike }).serviceWorker ??
        null));
  if (!workerContainer) {
    return;
  }

  workerContainer.register(SERVICE_WORKER_URL).catch((error) => {
    // Expected without a secure context (LAN development, plain http); the
    // line keeps the reason visible without feeding the error service.
    console.debug("Service worker registration skipped:", error);
  });
}
